module.exports = __webpack_public_path__ + "static/xtraCarry-16022d42b20bb5fb169fada3343223dd.svg";